<main class="fixed inset-0 z-10 overflow-y-auto bg-app-canvas" [ngStyle]="{ 'font-size': fontSize + 'px' }">
  <div class="mx-auto flex min-h-full w-full max-w-3xl flex-col justify-center px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))] sm:px-6 lg:py-10">
    <header class="mb-5 flex items-center gap-3 border-b border-app-brand-border-soft pb-4">
      <img src="/public/icons/icon-48x48.png" alt="" class="h-12 w-12 rounded-lg" aria-hidden="true">
      <div class="min-w-0">
        <p class="app-supporting-text text-app-brand-dark">碧雲莊社區時間銀行</p>
        <h1 class="app-page-title text-2xl text-app-ink">登入帳戶</h1>
      </div>
    </header>

    <div class="grid min-w-0 grid-cols-1 gap-5 lg:grid-cols-[minmax(0,24rem)_minmax(17rem,1fr)] lg:items-start lg:justify-center">
    <section class="min-w-0 lg:w-96">
    <form #loginForm="ngForm" (ngSubmit)="login()" class="rounded-lg border border-app-border bg-app-surface p-4 shadow-sm sm:p-5">
      <div class="relative mb-4">
        <label for="phone" class="app-field-label mb-2 block text-app-ink">電話號碼</label>
        <div class="relative">
          <i class="bi bi-telephone absolute left-3 top-1/2 -translate-y-1/2 text-app-ink-muted" aria-hidden="true"></i>
          <input #phoneInput class="app-control pl-10 pr-12" type="text" id="phone" name="phone"
            autocomplete="username" [(ngModel)]="phone" (input)="onPhoneInput()" required maxlength="12"
            placeholder="手機：0912345678 或市話：02-12345678">
          <button #toggleButton *ngIf="savedAccounts.length > 0" type="button"
            class="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg text-app-ink-muted focus:outline-none focus:ring-2 focus:ring-app-brand-soft"
            (click)="toggleAccountList()" [attr.aria-expanded]="showAccountList" aria-label="選擇已儲存帳號">
            <i class="bi" [ngClass]="showAccountList ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
          </button>
        </div>

        <section #accountDropdown *ngIf="showAccountList && savedAccounts.length > 0"
          class="absolute z-20 mt-1 max-h-80 w-full overflow-y-auto rounded-lg border border-app-border bg-app-surface shadow-lg"
          aria-label="已儲存帳號">
          <div class="flex min-h-12 items-center justify-between border-b border-app-border bg-app-surface-panel px-3">
            <strong>選擇帳號</strong>
            <button type="button" class="app-icon-button border-0 bg-transparent" (click)="showAccountList = false" aria-label="關閉帳號清單">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
          <div *ngFor="let account of savedAccounts" class="flex min-h-16 items-center gap-3 border-b border-app-border px-3 py-2 last:border-b-0">
            <button type="button" class="flex min-w-0 flex-1 items-center gap-3 text-left focus:outline-none focus:ring-2 focus:ring-app-brand-soft"
              (click)="selectSavedAccount(account)">
              <span class="flex h-11 w-11 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-app-brand-soft text-app-brand-dark">
                <img *ngIf="account.avatar" [src]="account.avatar" [alt]="account.name + '的頭像'" class="h-full w-full object-cover">
                <i *ngIf="!account.avatar" class="bi bi-person-fill" aria-hidden="true"></i>
              </span>
              <span class="min-w-0">
                <span class="block font-bold text-app-ink">{{ account.name }}</span>
                <span class="app-numeric block text-sm text-app-ink-muted">{{ account.phone.startsWith('+8869') ? '09' + account.phone.substring(5) : account.phone.startsWith('+886') ? '0' + account.phone.substring(4) : account.phone }}</span>
              </span>
            </button>
            <button type="button" class="app-icon-button border-0 text-app-danger" (click)="removeSavedAccount($event, account.phone)"
              [attr.aria-label]="'移除' + account.name + '帳號'" title="移除此帳號">
              <i class="bi bi-trash3" aria-hidden="true"></i>
            </button>
          </div>
          <div class="border-t border-app-border p-3">
            <button type="button" class="app-button-secondary w-full" (click)="useOtherAccount()">
              <i class="bi bi-person-plus" aria-hidden="true"></i><span>使用其他帳號</span>
            </button>
          </div>
        </section>
      </div>

      <div class="mb-4">
        <label for="password" class="app-field-label mb-2 block text-app-ink">密碼</label>
        <div class="relative">
          <i class="bi bi-lock absolute left-3 top-1/2 -translate-y-1/2 text-app-ink-muted" aria-hidden="true"></i>
          <input class="app-control pl-10 pr-12" [type]="showPassword ? 'text' : 'password'" id="password" name="password"
            autocomplete="current-password" [(ngModel)]="password" (input)="onPasswordInput()" required placeholder="請輸入您的密碼">
          <button type="button" class="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg text-app-ink-muted focus:outline-none focus:ring-2 focus:ring-app-brand-soft"
            (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? '隱藏密碼' : '顯示密碼'" [title]="showPassword ? '隱藏密碼' : '顯示密碼'">
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <label class="mb-4 flex min-h-10 items-center gap-3 text-app-ink">
        <input type="checkbox" [(ngModel)]="rememberAccount" name="rememberAccount"
          class="h-5 w-5 rounded border-app-border text-app-brand focus:ring-app-brand">
        <span>記住此帳號</span>
      </label>

      <button type="submit" [disabled]="!loginForm.valid || isLoading" class="app-button-primary w-full">
        <i *ngIf="isLoading" class="bi bi-arrow-repeat animate-spin" aria-hidden="true"></i>
        <span>{{ isLoading ? '登入中...' : '登入' }}</span>
      </button>
    </form>

    <p class="app-supporting-text mt-3 text-center text-app-ink-muted">
      還沒有帳號？
      <button type="button" (click)="goToRegister()" class="font-bold text-app-brand-dark underline focus:outline-none focus:ring-2 focus:ring-app-brand-soft">建立新帳戶</button>
    </p>
    <p class="app-supporting-text mt-2 px-1 text-center text-sm text-app-ink-muted">
      登入即代表您同意
      <button type="button" (click)="openModal()" class="font-bold text-app-brand-dark underline focus:outline-none focus:ring-2 focus:ring-app-brand-soft">使用者條款</button>
      與
      <button type="button" (click)="openModal()" class="font-bold text-app-brand-dark underline focus:outline-none focus:ring-2 focus:ring-app-brand-soft">隱私權條款</button>
    </p>
    </section>

    <aside class="border-l-4 border-app-highlight bg-app-highlight-soft p-4 text-app-ink lg:min-h-full lg:p-5">
      <h2 class="app-section-title mb-4 flex items-center gap-2 text-lg">
        <i class="bi bi-people-fill text-app-highlight-text" aria-hidden="true"></i><span>一起共好共養碧雲莊社區</span>
      </h2>
      <div class="space-y-3">
        <p class="app-numeric flex min-w-0 items-start gap-3"><i class="bi bi-telephone mt-1 flex-shrink-0 text-app-highlight-text" aria-hidden="true"></i><span><span class="block text-sm text-app-ink-muted">雲幣服務電話</span><strong class="break-all">0983-408335</strong></span></p>
        <p class="app-numeric flex min-w-0 items-start gap-3"><i class="bi bi-chat-dots mt-1 flex-shrink-0 text-app-highlight-text" aria-hidden="true"></i><span><span class="block text-sm text-app-ink-muted">LINE ID</span><strong class="break-all">0983-408335</strong></span></p>
      </div>
    </aside>
    </div>
  </div>
</main>

<div *ngIf="showModal" class="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="login-terms-title">
  <button type="button" class="absolute inset-0 bg-black/50" (click)="closeModal()" aria-label="關閉條款"></button>
  <section class="relative flex max-h-[90dvh] w-full max-w-2xl flex-col rounded-t-lg bg-app-surface shadow-xl sm:rounded-lg" [ngStyle]="{ 'font-size': fontSize + 'px' }">
    <header class="flex min-h-14 items-center justify-between border-b border-app-border px-4">
      <h2 id="login-terms-title" class="app-section-title flex items-center gap-2 text-xl text-app-ink"><i class="bi bi-file-earmark-text text-app-brand" aria-hidden="true"></i>使用者條款</h2>
      <button type="button" class="app-icon-button" (click)="closeModal()" aria-label="關閉"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
    </header>
    <div class="overflow-y-auto p-4 text-app-ink sm:p-6">
      <p class="mb-4">歡迎使用本服務。使用本服務即表示您同意以下條款及細則：</p>
      <ol class="list-decimal space-y-4 pl-6">
        <li><strong>服務說明：</strong>我們將盡力確保本服務的正常運作，然而，我們不保證服務不會中斷或無任何錯誤。</li>
        <li><strong>使用者行為：</strong>使用者應承諾不得以非法方式使用本服務，並不得侵犯他人權益或干擾服務的正常運作。</li>
        <li><strong>帳號安全：</strong>使用者有責任保護自己的帳號資訊，並應避免向他人泄露帳號或密碼。若發現異常活動，應立即通知我們。</li>
        <li><strong>智慧財產權：</strong>本服務及其內容（包括但不限於圖片、文字、軟體）均受智慧財產權法保護，未經許可不得擅自使用。</li>
        <li><strong>責任限制：</strong>對於使用者在本服務中所造成的任何損失或損害，我們不承擔任何責任，除非法律另有規定。</li>
        <li><strong>條款變更：</strong>我們保留隨時修改使用條款的權利，修改後的條款將自發布之日起生效。</li>
      </ol>
    </div>
    <footer class="border-t border-app-border p-4"><button type="button" class="app-button-primary w-full sm:ml-auto sm:w-auto" (click)="closeModal()">我同意</button></footer>
  </section>
</div>

<app-alert [show]="!!failMessage && !staticAlertClosed" [message]="failMessage" [type]="'danger'"
  [fontSize]="fontSize - 4" (closed)="staticAlertClosed = true"></app-alert>
